<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-5">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-12 text-center">
                        <img src="../../../assets/img/logo.png" alt="Admin Logo" class="animation__shake"
                            style="opacity: .8;height: 40px;">
                        <h5>Halo.. Selamat {{ waktu }} {{ namauser }}, <br> Selamat Datang di <br>
                            <span class="text-primary">Satu Data SSPSDA, silahkan pilih layanan yang tersedia</span>
                        </h5>
                    </div>
                    <div class="col-sm-12 text-center">&nbsp;</div>
                </div>
                <div class="row mb-2 text-center">
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/features-1.svg" alt="iemon" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">iemon PU</h5>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/features-2.svg" alt="monika" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">Monika</h5>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/features-3.svg" alt="loan" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">Loan Collection</h5>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/features-4.svg" alt="manda" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">Manda</h5>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/case-information-system.png" alt="imc" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">IMC</h5>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="../../../assets/img/visit.png" alt="sinta" class="animation__shake"
                            style="opacity: .8;height: 180px;">
                            <br></br><h5 class="animation__shake">Sinta</h5>
                    </div>
                </div>
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import swal from 'sweetalert2';
import Footer from "../componen/Footer.vue";
import NavBar from "../componen/NavBar.vue";
import Menu from "../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts, swal
    },
    data() {
        return {
            halamanloading: false,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            kewenangan: JSON.parse(localStorage.getItem("kewsistem")),
            id_user: JSON.parse(localStorage.getItem("iduser")),
            d5sistem: JSON.parse(localStorage.getItem("d5sistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            ipnya: '',
            waktu: '',
            selectedtahun: new Date().getFullYear(),
            tahun: new Date().getFullYear(),
        }
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        ontahunChange(a) {
            try {
                this.selectedtahun = this.listtahun[a].tag;
                this.ambildata();
            }
            catch (err) {
                return;
            }
        },
    },
    mounted() {
        this.getOtentifikasi();
        //this.AmbilDataReff();
        //this.ambildata();
        this.waktu = this.getWaktu();
        //alert(this.leveluser);
    },
}
</script>
<style></style>